/* __next_internal_client_entry_do_not_use__  auto */ import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
var initialStore = {
    category: null,
    navigationPath: null
};
var _createContextStore = createContextStore(initialStore, {
    name: "CurrentCategoryPageContext"
});
export var CurrentCategoryPageContextProvider = _createContextStore.Provider, useCurrentCategoryPage = _createContextStore.useStore;
